export default [{
  name: "Pablo Coll",
  title: "CFO, Tabacalera USA Inc.",
  linkedIn: "pablo-coll-mba-msf-32b81016/",
  image: require("../../assets/images/leadership/Pablo-Coll-2.png"),
}, {
  name: "Jason Williams",
  title: "Chief Human Resource Officer, Tabacalera USA Inc.",
  linkedIn: "jason-williams-mba-sphr-3a718313/",
  image: require("../../assets/images/leadership/Jason-Williams-2.png"),
}, {
  name: "Rafael Nodal",
  title: "Vice President of Product capability, Tabacalera USA Inc.",
  linkedIn: "",
  image: require("../../assets/images/leadership/Rafael_Nodal-3.jpg"),
}, {
  name: "Al Franz",
  title: "CIO, Tabacalera USA Inc.",
  linkedIn: "alfranz/",
  image: require("../../assets/images/leadership/Al_Franz.png"),
},  {
  name: "Millie Lukose",
  title: "Vice President and General Counsel, Tabacalera USA Inc.",
  linkedIn: "millie-p-lukose-89b2043/",
  image: require("../../assets/images/leadership/Millie-Lukose.png"),
}, {
  name: "Rhondetta Walton",
  title: "VP Regulatory Compliance, Tabacalera USA Inc.",
  linkedIn: "/rhondetta-walton-bb10221b4",
  image: require("../../assets/images/leadership/Rhondetta-Walton.png"),
}, {
  name: "Brad Winstead",
  title: "CEO, JR Cigar",
  linkedIn: "brad-winstead-46589916/",
  image: require("../../assets/images/leadership/Brad-Winstead-2.jpg"),
}, {
  name: "Davide Moro",
  title: "CEO, Altadis U.S.A.",
  linkedIn: "davide-moro/",
  image: require("../../assets/images/leadership/Davide-Moro.jpg"),
}, {
  name: "Sheri Sieminski",
  title: "CEO of CDM",
  linkedIn: "sherrisieminski/",
  image: require("../../assets/images/leadership/Sherri_Sieminski.png"),
}, {
  name: "Paul Waller",
  title: "Head of Sales, Altadis U.S.A.",
  linkedIn: "paul-waller-009a6226/",
  image: require("../../assets/images/leadership/paulwaller.jpeg"),
}, {
  name: "Oliver Hyams",
  title: "Vice President of Marketing and Trade Marketing, Altadis U.S.A.",
  linkedIn: "oliver-hyams-b62a9418/",
  image: require("../../assets/images/leadership/oliverhyams.jpg"),
}, {
  name: "Luis Campbell",
  title: "Chief Supply Chain Officer",
  linkedIn: "luis-e-campbell-32736339/",
  image: require("../../assets/images/leadership/Luis_Campbell.jpg"),
}, {
    name: "Frank Diaz",
    title: "Head of Business Intelligence",
    linkedIn: "frank-diaz/",
    image: require("../../assets/images/leadership/Frank-Diez.jpg"),
}];



// WEBPACK FOOTER //
// ./src/containers/Leadership/LeadershipData.ts